import _toConsumableArray from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.concat.js";
import { mapState } from "../../store/map";
import { getArchiveList } from "../../api/archive";
import { computed, reactive } from "vue";
import { defaultThumbnail, useDefaultThumbnail } from "../../utils/thumbnail";
export default {
  name: "ArchiveList",
  setup: function setup() {
    window.scrollTo({
      top: 0
    });
    var pageSize = 10;
    var archives = reactive([]);

    var _mapState = mapState("adminAbout"),
        articleCountInfo = _mapState.articleCountInfo;

    var articleCount = computed(function () {
      return parseInt(articleCountInfo.value.article);
    });
    onCurrentPageChanged(1);

    function onCurrentPageChanged(pageNum) {
      getArchiveList(pageNum, pageSize).then(function (data) {
        data.rows.forEach(function (archive) {
          archive.articles.forEach(function (article) {
            article.createTime = article.createTime.split(" ")[0];
            article.thumbnail = article.thumbnail || defaultThumbnail;
          });
        });
        archives.splice.apply(archives, [0, archives.length].concat(_toConsumableArray(data.rows))); // 多插入一个啥也没有的节点

        archives.push({
          year: "",
          articles: []
        });
      });
    }

    return {
      articleCount: articleCount,
      pageSize: pageSize,
      archives: archives,
      onCurrentPageChanged: onCurrentPageChanged,
      useDefaultThumbnail: useDefaultThumbnail
    };
  }
};